import { treaty, type Treaty } from '@elysiajs/eden'
import type { App } from '../../bot/src/index'
import type { DataMessage } from '../../shared/types/DataMessage'
import { useEffect, useState, useMemo, createContext } from 'react'
import { retrieveLaunchParams } from '@telegram-apps/sdk-react'
import Game from './roots/Game'
import Loading from './roots/Loading'
import { type GameState, isGameState } from '../../shared/types/GameState'
import type { Update } from '../../shared/types/Update'

const app = treaty<App>(
	import.meta.env.DEV
		? 'https://localhost.local:80'
		: 'https://hillaryserver.rizz.zone/'
)

const GameContext = createContext<GameState | null>(null)
const SetUpdateContext = createContext<((update: Update) => void) | null>(
	() => {}
)
export { GameContext, SetUpdateContext }
export default function App() {
	/*const [platform, isDark, firstName] = useMemo(() => {
		const platform = 'base'
		let isDark = false
		let username = ''
		try {
			const lp = retrieveLaunchParams()
			const { bgColor } = lp.themeParams
			if (lp.initData && lp.initData.user) username = lp.initData.user.firstName
			isDark = bgColor && isRGB(bgColor) ? isColorDark(bgColor) : false
		} catch {
			//
		}

		console.log(platform, isDark)

		return [platform, isDark, username]
	}, []) */

	const initDataRaw = useMemo(() => retrieveLaunchParams().initDataRaw, [])
	if (!initDataRaw) throw new Error('No initDataRaw')

	const [gameState, setGameState] = useState<GameState | null>(null)
	const [submitUpdate, setSubmitUpdate] = useState<
		((update: Update) => void) | null
	>(null)

	const [reconnections, setReconnections] = useState(0)

	useEffect(() => {
		console.log(`tma ${initDataRaw}`)
		const socket = app.ws.subscribe({
			query: { initDataRaw: initDataRaw }
		})
		const submitUpdateFunction = (update: Update) => {
			socket.send(update)
		}
		setSubmitUpdate(() => submitUpdateFunction)

		socket.subscribe((message) => {
			const typedMessage = message as Treaty.OnMessage<DataMessage>
			console.log(typedMessage)
			if (typedMessage.data.event === 'data')
				if (isGameState(typedMessage.data.data))
					setGameState({ ...typedMessage.data.data })
				else throw new Error('gameData is not a GameData')
		})
		socket.on('open', () => {
			socket.send('ayup')
		})
		socket.on('close', (event) => {
			console.log('closed')
			console.log(event)
			setReconnections(reconnections + 1)
		})

		const sendPing = () =>
			socket.send({ type: 'ping', id: crypto.randomUUID() })

		// Correction 1: Send a ping every 10 seconds. The server will respond with data, to double up as a resync
		const pingTask = setInterval(sendPing, 10000)

		// Correction 2: Always ping on refocus
		window.addEventListener('focus', sendPing)

		return () => {
			socket.close()
			clearInterval(pingTask)
			window.removeEventListener('focus', sendPing)
		}
	}, [reconnections])

	return gameState ? (
		<SetUpdateContext.Provider value={submitUpdate}>
			<GameContext.Provider value={gameState}>
				<Game />
			</GameContext.Provider>
		</SetUpdateContext.Provider>
	) : (
		<Loading />
	)
}
